import { IS_LAXMI_HOST } from './demo';

const LAXMI = {
  name: 'LAXMI CABLE VISION',
  portalUrl: 'https://www.laxmicablevision.in/portal',
  portalLabel: 'www.laxmicablevision.in/portal',
  email: 'laxmicablevision7@gmail.com',
  phone: '+91 93277 29619',
  phoneHref: '+919327729619',
};

// Who the Terms / Refund / Privacy pages speak for. Laxmi's addresses keep Laxmi's exact text;
// an operator's pages use their own company details (Settings > Company Details).
export const legalIdentity = ({ isLaxmi, identity }) => {
  if (isLaxmi) return LAXMI;
  const base = String(identity?.appUrl || '').replace(/\/+$/, '');
  return {
    name: (identity?.name || 'Orvyn').toUpperCase(),
    portalUrl: base ? `${base}/portal` : '',
    portalLabel: base ? `${base.replace(/^https?:\/\//, '')}/portal` : '',
    email: identity?.email || '',
    phone: identity?.phone || '',
    phoneHref: String(identity?.phone || '').replace(/[^\d+]/g, ''),
  };
};

export const legalFor = (identity) => legalIdentity({ isLaxmi: IS_LAXMI_HOST, identity });
